module.exports = __webpack_public_path__ + "static/img/CARD3.34e6e504.png";